<template>
	<div data-tour-scope="pages">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.pages') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- ordine e annidamento delle pagine: una pagina a parte -->
								<v-btn text title="Ordine delle pagine" data-tour="order" @click="ordina">
									<v-icon>mdi-sort</v-icon>
								</v-btn>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi pagina" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="8" data-tour="tools">
									<v-autocomplete
										v-model="settings.filters.categories"
										:items="pagineFiltro"
										item-value="id"
										item-text="text"
										label="Pagine"
										multiple
										chips
										small-chips
										deletable-chips
										clearable
										outlined
										dense
										hide-details
									></v-autocomplete>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getPages"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="page-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.trans ? item.trans.name : ''" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Dettaglio della pagina'" @click="apri(item)">
														<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div v-if="item.id !== 0" class="d-flex align-center justify-space-between" data-tour="switch">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<PageDetail v-if="aperto(item)" class="mt-2" :item="item" :pagine="pagineAlbero" :lingua="langDefault" @edit="editItem(item)" @delete="deleteItem(item)" />
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id">
											<td class="pl-1 pr-0 text-no-wrap" style="width: 76px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Dettaglio della pagina'" @click="apri(item)">
													<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td class="text-left">
												<div class="font-weight-medium">{{ item.trans.name }}</div>
												<div class="pg-sub pg-mono">{{ item.type === 'external_link' ? item.external_link : item.trans.slug ? '/' + item.trans.slug : '' }}</div>
											</td>
											<td>
												<v-chip x-small label outlined>
													<v-icon x-small left>{{ item.type === 'external_link' ? 'mdi-link-variant' : 'mdi-file-document-outline' }}</v-icon
													>{{ item.type === 'external_link' ? 'Link esterno' : 'Pagina' }}
												</v-chip>
											</td>
											<td>
												<v-chip v-if="item.menu_header" x-small label outlined color="primary" class="mr-1">header</v-chip>
												<v-chip v-if="item.menu_footer" x-small label outlined color="primary">footer</v-chip>
												<span v-if="!item.menu_header && !item.menu_footer" class="pg-sub">—</span>
											</td>
											<td class="pg-sub text-no-wrap">{{ item.created_at | moment('DD/MM/YYYY') }}</td>
											<td data-tour="switch">
												<v-switch v-if="item.id !== 0" v-model="item.is_active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="aperto(item)" :key="item._id + '-detail'" class="pg-expanded">
											<td :colspan="headers.length" class="py-3">
												<PageDetail :item="item" :pagine="pagineAlbero" :lingua="langDefault" @edit="editItem(item)" @delete="deleteItem(item)" />
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la pagina non potrai più ripristinarla: sparisce dal sito e dai menu.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createPagesTourSteps, stopPagesTour } from './pages-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import PageDetail from '@/components/ecommerce/page/PageDetail.vue';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Pages',
	// pagina, righe, ordinamento, ricerca e filtro stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { categories: 'numberArray' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createPagesTourSteps(), { onStop: stopPagesTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
		PageDetail,
	},
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				// pagine scelte nel filtro (id numerici)
				filters: { categories: [] },
				options: { sortBy: ['created_at'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			searchfield: '',
			total: 0,
			headers: [
				// colonna del menu a tre puntini e del dettaglio: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Pagina', value: 'trans.name' },
				{ text: 'Tipo', value: 'type' },
				{ text: 'Menu', value: 'menu_header' },
				{ text: 'Creata', value: 'created_at' },
				{ text: 'Attivo', value: 'is_active' },
			],
			// pagine con il dettaglio aperto (+)
			aperti: [],
			langDefault: '',
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	async created() {
		this.listLoad();
		await this.fetchSetting();
		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
	},
	computed: {
		// albero delle pagine appiattito (per il nome della pagina padre nel dettaglio)
		pagineAlbero() {
			const piatte = [];
			const visita = nodi =>
				(nodi || []).forEach(n => {
					piatte.push(n);
					visita(n.children);
				});
			visita(this.getSettings && this.getSettings.pages);
			return piatte;
		},
		// voci del filtro: tutte le pagine dell'albero, con il percorso dei padri nel nome
		pagineFiltro() {
			const voci = [];
			const visita = (nodi, percorso) =>
				(nodi || []).forEach(n => {
					const nome = this.nomePagina(n);
					const completo = percorso ? `${percorso} › ${nome}` : nome;
					voci.push({ id: n.id, text: completo });
					visita(n.children, completo);
				});
			visita(this.getSettings && this.getSettings.pages, '');
			return voci;
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getPages: 'pages/getPages',
			getSettings: 'settings/getSetting',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'pages/asyncFetchData',
			destroyData: 'pages/destroyData',
			setUpdateStatusPage: 'pages/setUpdateStatusPage',
			deletePages: 'pages/deletePages',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',
		}),
		nomePagina(n) {
			const trans = _.find(n.trans, { lang: this.langDefault }) || (n.trans || [])[0];
			return trans ? trans.name : '';
		},
		// i flag booleani in card diventano Sì/No, il resto resta com'è
		siNo(v) {
			if (typeof v === 'boolean') return v ? 'Sì' : 'No';
			return v;
		},
		aperto(item) {
			return this.aperti.includes(item._id);
		},
		apri(item) {
			this.aperti = this.aperto(item) ? this.aperti.filter(id => id !== item._id) : [...this.aperti, item._id];
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Creata', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'In header', value: this.siNo(item.menu_header) },
				{ label: 'In footer', value: this.siNo(item.menu_footer) },
				{ label: 'Tipologia', value: item.type },
			];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		changeStatus(item) {
			this.setPreload(true);
			this.setUpdateStatusPage({ _id: item._id, is_active: item.is_active })
				.then(result => {
					if (result && result.data && result.data.data && result.data.data.ok) this.notifica('success', 'Update successfully');
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		// inserimento, modifica e ordinamento sono pagine: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/ecommerce/pages/${item.id}`);
		},
		createItem() {
			this.$router.push('/ecommerce/pages/new');
		},
		ordina() {
			this.$router.push('/ecommerce/pages/order');
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.deletePages([this.daEliminare])
				.then(data => {
					// il server restituisce le impostazioni con l'albero delle pagine aggiornato
					if (data && data.data) this.updateData(data.data);
					return this.getDataFromApi();
				})
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>


<style scoped>
.pg-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.pg-mono {
	font-family: monospace;
}
.pg-expanded,
.pg-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.page-cards,
.page-cards tr {
	display: block;
	width: 100%;
}
.page-cards tr,
.page-cards tr:hover {
	background: transparent !important;
}
.page-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.page-cards tr:first-child td {
	padding-top: 12px !important;
}
.page-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.page-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
